import { envConfig } from "../env";
import GADConfig from "../google-automated-discount";
import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const ngDkFiMerchant = "5557157768";

const finland: MarketConfiguration = {
  code: MarketEnum.fi,
  label: "Finland",
  descriptiveLabel: "Finnish",
  testfreaksClientId: envConfig.NEXT_PUBLIC_FI_TESTFREAKS_CLIENT_ID,
  searchEngineUrl: envConfig.NEXT_PUBLIC_SEARCH_ENGINE_URL_FI,
  contentfulLocale: ContentfulEnum.fi,
  contentfulCountry: "Finland",
  locale: LocaleEnum.fi,
  serviceLocale: ServiceLocaleEnum.fi,
  language: {
    code: "fi",
    label: "Finnish",
    flag: "fi",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/fi",
  termsSlug: "ehdot-verkkokauppa",
  loop54Market: MarketEnum.fi,
  adyenMarket: MarketEnum.fi,
  elevateMarket: ElevateMarketEnum.fi,
  freeShippingThreshold: 100,
  externalStoreId: "ecom-fi",
  searchPathName: "haku",
  adyenCheckoutEnabled: false,
  walleyCheckoutEnabled: true,
  walleyB2CStoreId: envConfig.NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_FI,
  walleyB2BStoreId: envConfig.NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_FI,
  walleyWidgetEnabled: true,
  hasTrustPilot: false,
  region: RegionEnum.nordics,
  intraRegionOrder: 3,
  googleAutomatedDiscounts: {
    allowedInTest: {
      allowedMerchants: new Set([ngDkFiMerchant, GADConfig.testMerchantId]),
      allowedPublicKeys: [
        GADConfig.testPublicKey,
        GADConfig.googleProductionPublicKey,
      ],
    },
    allowedInProd: {
      allowedMerchants: new Set([ngDkFiMerchant]),
      allowedPublicKeys: [GADConfig.googleProductionPublicKey],
    },
  },
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
  eurobonus: false,
  eurobonusThreshold: 500,
};

export default finland;
